/*globals dashboardApp,WidgetDirective*/
import icon from './text.png.js';
import template from './text_widget_view.html';
import templateEditView from './text_widget_edit.html';
import templateMaxView from './text_widget_max.html';

angular
    .module('MW.Dashboard.TextWidget', [
        'CoreColorService',
        'MW.Dashboard.ExportService',
        'ngSanitize',
        'MW.Framework.TextFilters',
        'MW.Framework.WidgetStatus',
        'MW.Dashboard.DashboardWidgetService',
        'MW.Framework.AppChromeService',
        'MW.Framework.DataExportService',
        'MW.Framework.Breadcrumb',
        'MW.Framework.AppBarTitleService',
        'MW.Configuration'
    ])
    .run(['DashboardWidgetService', 'CoreColorService', 'DASHBOARD_LEGACY_URL', function(DashboardWidgetService, CoreColorService, DASHBOARD_LEGACY_URL) {
    DashboardWidgetService.register({
        name: 'Text',
        app: 'dashboard',
        description: 'The Text widget displays a block of text. The text to display can be added or configured in edit mode. It can be used to describe the purpose of the dashboard or describe the data being displayed on one or more of the widgets. ',
        directive: 'text-widget',
        icon,
        defaultSettings: {
            text: '',
            textColor: CoreColorService.colors.black,
            width: 'third'
        },
        displayOrder: 100,
        requiredSettings: ['text'],
        availableFilters : [],
        availableSettings : ['title'],
        hasCustomSettings: true,
        reportAs: 'html',
        template,
        templateEditView,
        templateMaxView,
        hasRequiredSettings: function hasRequiredSettings() {
            if(typeof this['settings'] === 'undefined') {
                return false;
            } else if (this.settings.text !== 'undefined' && this.settings.text !== '') {
                return true;
            } else {
                return false;
            }
        }
    });

}]);

angular
    .module('MW.Dashboard.TextWidget')
    .directive('textWidget', ['DashboardWidgetService', function(DashboardWidgetService){
    var textWidget = DashboardWidgetService.getWidget('text-widget');

    var textWidgetController = function textWidgetController ($scope){
        $scope.makeIt = function(color){
            $scope.widget.settings.textColor = '#' + color;
        };
    };

    var textWidgetLink = angular.noop;

    return new WidgetDirective(textWidget, textWidgetLink, textWidgetController);
}]);
